/* ── Overlay + scroll lock universale (iOS, Android, desktop) ── */
var _cartScrollY = 0;
var _cartOverlay = null;

function getCartOverlay() {
  if (!_cartOverlay) {
    _cartOverlay = document.createElement('div');
    _cartOverlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:99998;';
    document.body.appendChild(_cartOverlay);
  }
  return _cartOverlay;
}

function cartLockScroll() {
  _cartScrollY = window.scrollY || window.pageYOffset;
  getCartOverlay().style.display = 'block';
  var h = document.documentElement, b = document.body;
  h.style.overflow = 'hidden';
  h.style.height   = '100%';
  h.style.overscrollBehavior = 'none';
  b.style.overflow = 'hidden';
  b.style.height   = '100%';
  b.style.position = 'fixed';
  b.style.top      = '-' + _cartScrollY + 'px';
  b.style.width    = '100%';
  b.style.overscrollBehavior = 'none';
}

function cartUnlockScroll() {
  if (_cartOverlay) _cartOverlay.style.display = 'none';
  var h = document.documentElement, b = document.body;
  /* scrollTo solo se il body era realmente bloccato: i listener di chiusura
     possono richiamare unlock a ogni click e senza guardia la pagina
     saltava in alto prima di navigare */
  var wasLocked = b.style.position === 'fixed';
  h.style.overflow = '';
  h.style.height   = '';
  h.style.overscrollBehavior = '';
  b.style.overflow = '';
  b.style.height   = '';
  b.style.position = '';
  b.style.top      = '';
  b.style.width    = '';
  b.style.overscrollBehavior = '';
  if (wasLocked) window.scrollTo(0, _cartScrollY);
}

/* ── Apertura drawer carrello via event delegation — funziona su tutti i device
   anche se il custom element non è ancora registrato al momento del tap ── */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('open-minicart');
  if (!btn) return;
  e.preventDefault();
  var drawer = document.getElementById('mini-cart-drawer');
  if (!drawer) return;
  drawer.classList.add('animate', 'active');
  document.body.classList.add('added__overlay');
  cartLockScroll();
}, true); /* capture: intercetta prima di qualsiasi handler sull'elemento */

class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").deleteQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
      document.getElementById("mini-cart-drawer").classList.add("loading-bar");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("mini-cart-drawer");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.notification?.addEventListener("click", (event) => {
      if (!event.target.classList.contains("cart-notification__close")) return;
      this.close();
    });

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (
      !event.target.closest("select") &&
      !event.target.closest('[name="attributes[gift-wrapping]"]') &&
      !event.target.closest('[name="note"]') &&
      !event.target.closest("shipping-calculator") &&
      !event.target.closest("discount-code") &&
      !event.target.closest("gift-wrap-message")
    ) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
      document
        .querySelector(".cart_action_drawer_overlay")
        .classList.add("active");
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");
    cartLockScroll();

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.getElementById("mini-cart-drawer").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");
    cartUnlockScroll();
    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState) {
    const sections = parsedState.sections || {};
    if (sections["mini-cart-drawer"]) {
      this.getSectionsToRender().forEach((section) => {
        const renderSelector = document.getElementById(section.id);
        const renderCartItemCount = document.getElementById("cart-notification-count-mobile");
        if (renderSelector && sections[section.id]) {
          renderSelector.innerHTML = this.getSectionInnerHTML(sections[section.id]);
        }
        if (renderCartItemCount && sections["cart-notification-count"])
          renderCartItemCount.innerHTML = this.getSectionInnerHTML(sections["cart-notification-count"]);
      });
      if (this.header) this.header.reveal();
      this.open();
    } else {
      fetch("/?sections=mini-cart-drawer")
        .then((r) => r.json())
        .then((fetched) => {
          const renderSelector = document.getElementById("mini-cart-drawer");
          if (renderSelector && fetched["mini-cart-drawer"]) {
            renderSelector.innerHTML = this.getSectionInnerHTML(fetched["mini-cart-drawer"]);
          }
          if (this.header) this.header.reveal();
          this.open();
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart-drawer",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  /* ------------------------------------------------------------------
     Stessi avvisi della pagina carrello, ma dentro il drawer laterale.
     Il vecchio controllo "currentItemCount === itemCount" non scattava
     mai perche' su 422 Shopify non restituisce item_count: qui leggiamo
     lo stato HTTP e mostriamo il messaggio del negozio.
     ------------------------------------------------------------------ */
  nidoMessaggioScorte(quantita) {
    const modello =
      (window.cartStrings && window.cartStrings.quantityError) ||
      "Puoi aggiungere soltanto [quantity] di questo articolo al tuo carrello.";
    return modello.replace("[quantity]", quantita);
  }

  nidoMessaggioGenerico() {
    return (
      (window.cartStrings && window.cartStrings.error) ||
      "Si e' verificato un errore durante l'aggiornamento del carrello. Riprova piu' tardi."
    );
  }

  nidoPulisciAvvisi() {
    /* Nel drawer la riga d'errore si chiama .drawer_cart-item__error
       (snippets/cart-item-notification.liquid) e resta nascosta finche'
       porta la classe no-js-inline. */
    document
      .querySelectorAll(
        "#mini-cart-drawer .drawer_cart-item__error, #mini-cart-drawer .cart-item__error"
      )
      .forEach((avviso) => {
        const testo = avviso.querySelector(".cart-item__error-text");
        if (testo) testo.textContent = "";
        avviso.classList.add("no-js-inline");
        avviso.classList.remove("cart-item__error--visible");
      });
  }

  nidoMostraAvviso(line, messaggio) {
    if (!messaggio) return;

    const contenitore = document.getElementById(`Line-item-error-${line}`);
    if (contenitore) {
      const testo = contenitore.querySelector(".cart-item__error-text");
      if (testo) testo.textContent = messaggio;
      contenitore.classList.remove("no-js-inline");
      contenitore.classList.add("cart-item__error--visible");
    }

    if (window.nidoAlert) window.nidoAlert(messaggio);
  }

  nidoErroreDaRisposta(stato, dati) {
    if (!dati) return this.nidoMessaggioGenerico();
    const inErrore = stato >= 400 || dati.status >= 400 || dati.errors;
    if (!inErrore) return null;
    return (
      dati.description ||
      dati.message ||
      (typeof dati.errors === "string" ? dati.errors : null) ||
      this.nidoMessaggioGenerico()
    );
  }

  /* Legge stato HTTP e corpo insieme: response.text() da solo perde il 422. */
  nidoLeggiRisposta(response) {
    return response.text().then((testo) => {
      let dati = null;
      try {
        dati = JSON.parse(testo);
      } catch (e) {
        dati = null;
      }
      return { stato: response.status, dati };
    });
  }

  nidoChiudiCaricamento() {
    const overlay = document.querySelector(".cart_action_drawer_overlay");
    if (overlay) overlay.classList.remove("active");
    if (this.notification) this.notification.classList.remove("loading-bar");
  }

  updateQuantity(line, quantity, name) {
    const campo = document.getElementById(`Quantity-${line}`);
    const precedente = campo ? campo.getAttribute("value") || campo.value : null;
    const richiesta = parseInt(quantity, 10);

    this.nidoPulisciAvvisi();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => this.nidoLeggiRisposta(response))
      .then(({ stato, dati }) => {
        const errore = this.nidoErroreDaRisposta(stato, dati);

        if (errore) {
          /* Su 422 non arrivano sezioni: il drawer resta com'e', si
             ripristina il valore nel campo e si scrive l'avviso. */
          if (campo) campo.value = precedente;
          this.nidoMostraAvviso(line, errore);
          return;
        }

        this.renderContents(dati);

        /* Quantita' limitata in silenzio (200 con meno pezzi del richiesto). */
        const campoNuovo = document.getElementById(`Quantity-${line}`);
        const applicata = campoNuovo ? parseInt(campoNuovo.value, 10) : NaN;
        if (!isNaN(applicata) && !isNaN(richiesta) && applicata < richiesta) {
          this.nidoMostraAvviso(line, this.nidoMessaggioScorte(applicata));
        }

        this.updateLiveRegions(line, dati.item_count);
      })
      .catch((e) => {
        console.error("Drawer carrello: aggiornamento quantita' fallito", e);
        if (campo) campo.value = precedente;
        this.nidoMostraAvviso(line, this.nidoMessaggioGenerico());
      })
      .finally(() => {
        this.nidoChiudiCaricamento();
      });
  }

  /* Tiene solo il conteggio aggiornato: l'avviso lo scrive updateQuantity. */
  updateLiveRegions(line, itemCount) {
    if (typeof itemCount === "number") this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    this.nidoPulisciAvvisi();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => this.nidoLeggiRisposta(response))
      .then(({ stato, dati }) => {
        const errore = this.nidoErroreDaRisposta(stato, dati);

        if (errore) {
          this.nidoMostraAvviso(line, errore);
          return;
        }

        this.renderContents(dati);
        this.updateLiveRegions(line, dati.item_count);
      })
      .catch((e) => {
        console.error("Drawer carrello: rimozione riga fallita", e);
      })
      .finally(() => {
        this.nidoChiudiCaricamento();
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("mini-cart-drawer");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.miniCartClose()
      );
    }
  }

  onClickMiniCart() {
    document
      .getElementById("mini-cart-drawer")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");
    cartLockScroll();

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("mini-cart-drawer").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");
    cartUnlockScroll();
    document.body.removeEventListener("click", this.onBodyClassRemove);
    removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    //console.log(eventTarget);
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
